module.exports = __webpack_public_path__ + "static/media/2.174a2fbd.png";